import { combineReducers } from "redux";
import "./authoring/index.js";
import { unifiedRootReducer } from "./authoring/reducers.js";
const rootReducer = {
  api: combineReducers({
    authoring: unifiedRootReducer
  })
};
export {
  rootReducer as default,
  rootReducer
};
//# sourceMappingURL=reducers.js.map
